import { DefinitionModel } from "../../types/ShareHolderRightsModel";

export function DefinitionsTable({
  definitionData,
  currentTab,
  globalFilterText,
  type,
}: {
  definitionData: DefinitionModel[];
  currentTab: string;
  globalFilterText: string;
  type: string;
}) {
  return (
    <div className="bg-white mt-4">
      <div className="px-10">
        {definitionData?.length > 0 && (
          <div className="-my-2 overflow-x-auto sm:-mx-6">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden md:rounded-lg border-2 border-stone-200 bg-white">
                <div>
                  <table className="min-w-full bg-white p-5">
                    <thead>
                      <tr className="border-b-2 border-stone-200 bg-gray-50">
                        <th
                          scope="col"
                          className={`py-3.5 border-l-2 border-stone-200  pr-3 text-left text-sm font-semibold text-stone-500
                           sm:pl-6 hover:cursor-pointer w-80`}
                        >
                          Definitions Name
                        </th>
                        <th
                          scope="col"
                          className={`py-3.5 border-l-2 border-stone-200  pr-3 text-left text-sm font-semibold text-stone-500
                           sm:pl-6 hover:cursor-pointer`}
                        >
                          Definitions Description
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {definitionData.map((definition, index) => (
                        <tr
                          key={`${definition.name}}${index}`}
                          className={`cursor-pointer hover:bg-slate-100 ${
                            !(index % 2) ? "bg-white" : "bg-gray-50"
                          } ${
                            definition.name !==
                            (index === 0
                              ? ""
                              : definitionData[index - 1].name || "")
                              ? "border-t-2 border-stone-200"
                              : ""
                          }`}
                        >
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 break-words text-sm font-bold text-stone-700 sm:pl-6 border border-dashed">
                            {definition.name}
                          </td>
                          <td className="max-w-xs whitespace-normal break-words py-4 pl-4 pr-3 text-sm text-stone-600">
                            {definition.description}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
